import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { setLocalStorageValue } from './localstorage'
import { postData, getRemoteUrl } from './request'
import { addCases } from './utils'

export const loginTokenKey = 'trainer/loginToken'

export const AuthorizationStatus = {
    none: 'none',
    logging: 'logging',
    authorized: 'authorized'
}

function setLoginToken(state, { payload }) {
    state.token = payload
    state.status = state.token.length > 0 ? AuthorizationStatus.authorized : AuthorizationStatus.none
}

function startLogin(state) {
    state.status = AuthorizationStatus.logging
    delete state.loginError
}

function setLoginError(state, { error }) {
    state.status = AuthorizationStatus.none
    state.loginError = error
}

function setRegistrationStatus(state, { payload }) {
    state.registrationSuccess = true
    delete state.registrationError
}

function startRegistration(state) {
    delete state.registrationError
    delete state.registrationSuccess
}


function setRegistrationError(state, { error }) {
    state.registrationError = error
    delete state.registrationSuccess
}

function postLogin(data) {
    return postData(getRemoteUrl("auth/login"), {
        login: data.login,
        password: data.password,
        remember_me: data.remember
    })
        .then(json => {
            let result

            if (json) {
                result = json.access_token
            }

            if (!result || !result.length) {
                throw new Error('Неверный логин или пароль')
            } else if (data.remember) {
                const expiresIn = (json && json.expires_in) || (3600 * 24)
                setLocalStorageValue(loginTokenKey, {
                    token: result,
                    expiration: Date.now() + (expiresIn * 1000)
                })
            }

            return result
        })
}

function registerUser(data) {
    return postData(getRemoteUrl('auth/register'), {
        login: data.login,
        password: data.password,
        first_name: data.first_name,
        second_name: data.second_name,
        email: data.email
    })
        .then(json => {
            let token

            if (json) {
                token = json.confirm_token
            }

            if (!token || !token.length) {
                throw new Error('Отказ в регистрации')
            }

            return postData(getRemoteUrl('auth/confirm'), { token })
        })
        .catch(err => {
            if (err && err.code === 'Duplicate') {
                throw new Error(`Пользователь с логином ${data.login} уже существует`)
            }

            throw err
        })
}

export const asyncDoLogin = createAsyncThunk('asyncDoLogin', postLogin)
export const asyncRegisterUser = createAsyncThunk('asyncRegisterUser', registerUser)

export const loginSlice = createSlice({
    name: 'login',
    initialState: {
        token: "",
        status: AuthorizationStatus.none,
        registrationSuccess: false
    },

    reducers: {
        setToken(state, value) {
            setLoginToken(state, value)
        },
        sessionExpired(state) {
            state.token = ''
            state.status = AuthorizationStatus.none
            state.loginError = 'Сеанс авторизации истёк. Войдите заново.'
        }
    },

    extraReducers: builder => {
        addCases(builder, asyncDoLogin, setLoginToken, startLogin, setLoginError)
        addCases(builder, asyncRegisterUser, setRegistrationStatus, startRegistration, setRegistrationError)
    }
})

export const { setToken, sessionExpired } = loginSlice.actions
